<script lang="ts">
	//Formatters
	import { format } from 'svelte-i18n';
	//Helpers
	import { real_id } from '../../../helpers/interface_helpers';
	import { onSettingsResponse } from '../../../helpers/device_settings_helpers';
	//Services
	import { postReq } from '../../../services/http';
	//Design system components
	import { Button } from '@Shelly/shelly-design-system';
	import SettingGuide from '../SettingGuide.svelte';
	//Types
	import type { Device } from '../../../types/Device';
	import { getContext, onDestroy } from 'svelte';
	import type { Writable } from 'svelte/store';
	import { showNewLayout } from 'src/stores/toDelete/new_layout';
	import type { SidepanelStickyBottomProps } from 'src/components/Sidepanel/sidepanel-types';

	export let device: Device;
	export let isOffline;
	export let useNewLayout = false;

	let waitForResponse = false;

	const handleReconnect = async () => {
		waitForResponse = true;
		const res = await postReq(`/device/generic_command`, {
			id: real_id(device.id),
			command: 'sta_cache_reset',
			payload: `{}`,
		});
		onSettingsResponse(res, device, {
			success: $format('reconnect_scc_toast', {
				default: 'Device will try to reconnect to the strongest Wi-Fi network.',
			}),
			danger: $format('reconnect_err_toast', {
				default: 'Failed to initiate connection process.',
			}),
		});
		waitForResponse = false;
	};

	const stickyBottomAction =
		getContext<Writable<SidepanelStickyBottomProps | null>>('stickyBottomAction');

	$: if (stickyBottomAction) {
		if ($showNewLayout) {
			stickyBottomAction.set({
				onClick: handleReconnect,
				loading: waitForResponse,
				disabled: isOffline,
				label: $format('button_reconnect', { default: 'reconnect' }),
			});
		} else {
			stickyBottomAction.set(null);
		}
	}

	onDestroy(() => {
		stickyBottomAction?.set(null);
	});
</script>

<SettingGuide
	text={$format('settings_guide_wifi_reconnect', {
		default: 'Clear the saved Wi-Fi cache and reconnect to the strongest network in range.',
	})}
/>
{#if !useNewLayout}
	<Button
		size="m"
		class={'mt-s'}
		width="full"
		on:click={handleReconnect}
		loading={waitForResponse}
		disabled={isOffline}
		>{$format('button_reconnect', {
			default: 'reconnect',
		})}</Button
	>
{/if}
